import React, { Component } from 'react';
import { Field, reduxForm } from "redux-form";
import {Link} from "react-router-dom";
import { connect } from "react-redux";
import { alphaNumeric } from "../../constants/ValidationRules";

import './CreateUserName.css'
import {updateUserName} from "../../actions";
import { renderFieldForModal } from "../common_page_elements";
import {minLength2, required} from "../../constants/ValidationRules";

const NAME = 'name'
;
/**
 * Goes inside a modal to update just the location name/description.
 */
class CreateUserName extends Component {

    onSubmit(values) {

        const { user, closeModalCallback } = this.props;

        this.props.updateUser(user.id, values[NAME], () => {
            closeModalCallback();
        });
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <div>
                <h4 className="location-update-dialog-buffer"> Enter a user name </h4>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <div>
                            <p> A treasure hunt needs a named author.  That’s you!  <br/>
                                Please enter a user name now. </p>
                            <div>
                                <Field
                                    name={NAME}
                                    component={ renderFieldForModal }
                                    validate={[required, minLength2, alphaNumeric]}
                                    warn={alphaNumeric}
                                    placeholder="Name"
                                />
                            </div>
                        <div>
                        <span className="left">
                            <Link className="btn-outline-secondary" to='/games'> Cancel Create Game </Link>
                        </span>
                            <span className="right">
                            <button type="submit" className="btn-primary">
                                Save
                            </button>
                        </span>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

// pull in app-wide (redux) state
function mapStateToProps(state) {
    return {
        user: state.userState.user
    };
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
CreateUserName = reduxForm({
    form: 'CreateUserNameForm' // a unique identifier for this form
})(
    connect(mapStateToProps, { updateUser: updateUserName }
)(CreateUserName));


export default CreateUserName;



// WEBPACK FOOTER //
// ./src/components/huntwizard/CreateUserName.js